<template>
  <el-select size="small" v-model="selectedMember" :placeholder="$t('select.user')" style="width: 180px"
             @change="handleChange"
             v-select-load-more="loadMore">
    <el-option
        v-for="member in tableData"
        :key="member.id"
        :label="member.userName"
        :value="member.userId"
    />
    <el-option v-if="isSuperAdmin || isAdmin" :label="$t('common.all')" :value="$t('common.all')"></el-option>
  </el-select>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {throttle} from "@/utils/mylodash";
import {getTeamUserList, getTeamUserListAll} from "@/api/groups";
import {Storage} from "@/utils/storage";

const emit = defineEmits(['selectChange'])
const {element} = defineProps({
  element: {
    type: Object,
    default: () => ({})
  }
})
const store = useStore()
const teamId = computed(() => store.state.email.teamID)
const targetTeamId = computed(() => element.teamId ? element.teamId : teamId)
const userInfo = computed(() => store.state.user.userInfo)

const ACCOUNTS_STORAGE_KEY = 'accounts'
const activeUserId = computed(() => {
  const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
  const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
  const id = fromUserInfo ?? fromAccounts
  return id === undefined || id === null ? '' : String(id)
})
// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])

const selectedMember = ref(null);
const members = ref([{id: 1, name: 'jack'}, {id: 2, name: 'petter'}])


onMounted(async () => {
  await getUserList()
})

// 分页
const pageNo = ref(1)
const pageSize = ref(20)
const total = ref(0)
// 成员信息
const tableData = ref([])
const getUserList = async () => {
  await getTeamUserListAll({
    teamId: targetTeamId.value,
    pageNo: pageNo.value,
    pageSize: pageSize.value
  }).then((res) => {
    // console.log(res, "所有的成员");
    pageNo.value = res.result.current;
    total.value = res.result.total;
    tableData.value = res.result;
    // 选中第一个
    console.log(tableData, 'tableData')
    selectedMember.value = tableData.value && tableData.value.length > 0 ? tableData.value.filter(item => String(item.userId) === activeUserId.value).length > 0 ? tableData.value.filter(item => String(item.userId) === activeUserId.value)[0].userId : tableData.value[tableData.value.length - 1].userId : null
    // console.log(selectedMember.value,'selectedMember.value')
    emit('update:selectedMember', selectedMember.value)
  });
}


const loadMore = throttle(async () => {
  console.log("more")
  if (pageNo.value === Math.ceil(total.value / pageSize.value)) {
    return
  } else {
    pageNo.value++
    await getUserList()
  }
}, 500)

const handleChange = (val) => {
  emit('update:selectedMember', val)
}


defineExpose({
  selectedMember,
})
</script>